import { render } from "./Checkbox.vue?vue&type=template&id=29f5d48c"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=29f5d48c&lang=css"
script.render = render

export default script